<template>
  <aha-modal
    title="Add slide to PowerPoint"
    @hide="hideModal"
  >
    <div
      class="tab-content"
      v-if="type === 'imageChoice' || type === 'multipleChoice'
        || type === 'wordCloud' || type === 'question' ||
        type === 'leaderboard' || type === 'spinnerWheel' ||
        (type === 'pickAnswer' && slideType === null) ||
        (type === 'pickAnswer' && slideType === 'imageChoice')
      "
    >
      <div class="text-center">
        <img src="@/assets/images/ppt/ppt-intro.svg" class="m-auto">
      </div>
      <div class="text-left mt-4">
        <div class="my-4 mb-1 flex items-center">
          <span class="step-number"><b>1</b></span>
          <span class="step-content">
            In PowerPoint, <strong> download </strong> the <strong>
              <a target="_blank" @click="trackingClickDA">AhaSlides add-in</a>
              <aha-icon
                name="open-new-window"
                class="text-base-80 mb-1"
                width="20"
                height="20"
              />
            </strong>
          </span>
        </div>
        <div class="my-4">
          <span class="step-number"><b>2</b></span>
          <span class="step-content"><b>Copy</b> the slide link below.</span>
        </div>
        <div class="mt-4 flex items-center">
          <span class="step-number"><b>3</b></span>
          <span class="step-content">
            <b>Paste</b> the link on the AhaSlides add-in.
          </span>
        </div>
      </div>
      <div class="text-right mt-10">
        <div class="tutorial-link inline-flex float-left mt-2">
          <a
            :href="youtubeLink"
            class="float-left text-base-80 contents"
            target="_blank"
            @click="trackingClickTutorial"
          >
            <img
              class="mr-1"
              :src="require('@/assets/images/icon/play.svg')"
            >
            <b>Tutorial</b>
          </a>
        </div>
        <aha-button class="px-6" @click="copySlideUrl">
          <i class="fas fa-link mr-1" style="font-size:12px;"></i>Copy link
        </aha-button>
        <aha-button variant="base" class="ml-2" @click="doneModal">
          Done
        </aha-button>
      </div>
    </div>
    <div class="tab-content" v-else>
      <div class="text-center">
        <img src="@/assets/images/ppt/ppt-coming-soon-2.svg" class="m-auto">
        <p class="mx-10 mt-6">
          This Slide type are coming soon to our
          <strong>
            <a target="_blank" @click="trackingClickDA">AhaSlides add-in</a>
            <aha-icon
              name="open-new-window"
              class="text-base-80 mb-1"
              width="20"
              height="20"
            />
          </strong>
        </p>
      </div>
      <div class="text-right mt-6">
        <aha-button variant="base" class="ml-2" @click="hideModal">
          Done
        </aha-button>
      </div>
    </div>
  </aha-modal>
</template>

<script>
import Utils from '@/util'
import config from '@/config'
import constants from '@/constant'

const { gaCategories } = constants
const appSourceLink = 'https://appsource.microsoft.com/en-us/product/office/WA200004824'
const youtubeLink = 'https://www.youtube.com/watch?v=pQfgGpkqdLQ'
export default {
  props: {
    slideType: {
      default: '',
      type: String,
    },
    type: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      youtubeLink,
      appSourceLink,
    }
  },
  mounted() {
  },
  methods: {
    copySlideUrl(e) {
      e.stopPropagation()
      const copiedLink = `${config.powerpointDomain}/slide/${this.$store.state.slideActive.id}`
      navigator.clipboard.writeText(copiedLink)
      Utils.showToastSuccess('Link copied!')
      const slideName = Utils.getCorrectSlideTypeName(this.type, this.slideType)
      Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Copy link', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    trackingClickTutorial() {
      const slideName = Utils.getCorrectSlideTypeName(this.type, this.slideType)
      Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Play tutorial', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    // eslint-disable-next-line sonarjs/no-identical-functions
    trackingClickDA() {
      window.open(appSourceLink, '_blank')
      const slideName = Utils.getCorrectSlideTypeName(this.type, this.slideType)
      Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Open AhaSlides add-in download page', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    hideModal() {
      this.$emit('hide')
    },
    doneModal() {
      this.$emit('done')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.tab-content {
  @apply pt-4 pb-4;
  @apply relative text-center;
}
.step-number {
  width: 28px;
  height: 28px;
  background-color: #DDECFF;
  border-radius: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  b {
    color: #4F9BF3;
  }
}
.tab-content {
  strong {
    a {
      color: #348EF6;
    }
    svg {
      color: #348EF6;
    }
  }
}
.step-content {
  @apply ml-2;
  width: 20rem;
}
a {
  cursor: pointer;
}
.tutorial-link {
  &:hover {
    img {
      filter: invert(47%) sepia(29%)
      saturate(4907%) hue-rotate(195deg) brightness(102%) contrast(93%);
    }
  }
}
</style>
